import { GroupMemberData } from '../dto/EntityRepository';
import { UpdateGroupMemberBulkReq, UpdateGroupMemberReq } from '../dto/ReqDtoRepository';

/**
 * 부분 수정이어도 현재 값을 같이 보낸다.
 * nameEn, country, year, email, contact, description, descriptionEn, sns는 키가 없으면 null로 지워진다.
 * tagIds는 최종 목록. 생략하면 태그 유지이므로, 로컬 스냅샷을 저장할 때는 항상 넣는다.
 */
export const toUpdateGroupMemberItemReq = (member: GroupMemberData): UpdateGroupMemberReq => ({
  id: member.id,
  name: member.name,
  nameEn: member.nameEn,
  role: member.role,
  country: member.country,
  year: member.year,
  email: member.email ?? '',
  contact: member.contact ?? '',
  description: member.description,
  descriptionEn: member.descriptionEn,
  sns: member.sns,
  tagIds: member.tags.map((tag) => tag.id),
});

/** hasChanged인 항목만 모은다. 없으면 null (빈 groupMemberList는 API 실패). */
export const toUpdateGroupMemberBulkReq = (
  groupMemberList: GroupMemberData[],
): UpdateGroupMemberBulkReq | null => {
  const nextList = groupMemberList
    .filter((member) => member.hasChanged)
    .map(toUpdateGroupMemberItemReq);
  if (nextList.length === 0) return null;
  return { groupMemberList: nextList };
};
